// extracted by mini-css-extract-plugin
export default {"logoIcon":"styles_logoIcon__J8FtH"};